// src/supabaseClient.js (Vite Edition)

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// 檢查環境變數是否存在（幫助調試白屏問題）
if (!supabaseUrl) {
  console.error('❌ Missing VITE_SUPABASE_URL environment variable')
}
if (!supabaseAnonKey) {
  console.error('❌ Missing VITE_SUPABASE_ANON_KEY environment variable')
}

export const supabase = createClient(
  supabaseUrl || '', 
  supabaseAnonKey || ''
)
